import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ColorMode = 'light' | 'dark' | 'system';

type ThemeStore = {
  colorMode: ColorMode;
  setColorMode: (mode: ColorMode) => void;
};

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      colorMode: 'system',
      setColorMode: (colorMode) => set({ colorMode }),
    }),
    { name: 'theme-preference' },
  ),
);
